import { RecurrenceType } from '../models/RecurrenceType';

/**
 * Maps frequency string values from the UI to RecurrenceType enum values
 * @param frequency - The frequency string from the form
 * @returns The corresponding RecurrenceType enum value
 */
export const mapFrequencyToRecurrenceType = (frequency: string): RecurrenceType => {
  switch (frequency) {
    case 'none':
      return RecurrenceType.No;
    case 'daily':
      return RecurrenceType.Daily;
    case 'weekday':
      return RecurrenceType.DailyWorkdays;
    case 'weekly':
      return RecurrenceType.Weekly;
    case 'monthly':
      return RecurrenceType.MonthlyDayNumber;
    case 'custom':
      // For now, default to No recurrence for custom
      // This could be expanded to handle custom logic
      return RecurrenceType.No;
    default:
      return RecurrenceType.No;
  }
};
